import { Selection } from '@react-three/postprocessing'
import { Suspense } from 'react'
import { PCFShadowMap } from 'three'

import { CameraRig } from '@components/camera'
import { Canvas, Helpers, SoundBoard } from '@components/helpers'
import { Loading, TouchControls, WidthWarning } from '@components/ui'

import { KeyboardControls, Preload } from '@react-three/drei'
import { CloudTransition } from './CloudTransition'
import { Environment } from './Environment'
import { GameLoop } from './GameLoop'
import { Level } from './Level'
import { PostProcessing } from './PostProcessing'

export function Experience() {
  return (
    <>
      <Canvas
        gl={{ powerPreference: 'high-performance' }}
        shadows={{ type: PCFShadowMap }}
        orthographic
        camera={{ zoom: 100, near: -1000, far: 1000 }}
      >
        <CameraRig />
        <Environment />

        <KeyboardControls
          map={[
            { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
            { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
          ]}
        >
          <Selection>
            <Suspense fallback={<Loading />}>
              <Level />
              <Preload all />
            </Suspense>
            <PostProcessing />
          </Selection>
          <GameLoop />
          <SoundBoard />
        </KeyboardControls>

        <CloudTransition />
        <WidthWarning />

        <Helpers />
      </Canvas>

      <TouchControls />
    </>
  )
}
